/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {obtainUnitSlug} from '../api'

export const useMutationObtainUnitSlug = createReactQueryMutationHook('obtainUnitSlug', obtainUnitSlug)
